<template lang="pug">
#lista-monitoramento-agricola
    .reorganizarMapaTabela
        | {{ $t('mensagens.monitoramentoAgricola.reorganizarMapaTabela') }}
        span.reorganizarMapaTabela--reorganizar-icon(
            @click='organizarLayout',
            :class='[larguraTotal ? "rotate" : ""]'
        )
            i.lyra-icon.lyra-pontos

    .lista-monitoramento-agricola__container(
        :class='[larguraTotal ? "isOrganizarWidth" : ""]',
        v-loading='carregando'
    )
        .territorio-monitoramento-tabela
            h3(style='height: 40px') {{ $t('mensagens.monitoramentoAgricola.listagemTerritoriosMonitorados') }}
                BaseButton.mr-3(
                    style='font-weight: bold',
                    type='text',
                    icon='el-icon-download',
                    @click='buscarPlanilhaMonitoramento()'
                ) {{ $t('mensagens.comuns.monitoramento.exportarMonitoramentos') }}
            .tabela
                TabelaMonitoramentoAgricolaParaguai(
                    v-if='paginaAreasMonitoradas !== {}',
                    :paginaAreasMonitoradas='paginaAreasMonitoradas',
                    :paginacao='paginacao',
                    :larguraTotal='larguraTotal',
                    :key='keyLista',
                    @ordenar='ordenar',
                    @mudarPagina='mudarPagina',
                    @salvarFiltro='salvarFiltroMonitoramento'
                )

        .territorio-monitoramento-mapa
            mapa(
                height='100%',
                idMapa='MapaListagemMonitoramentoAgricola',
                :key='keyMapa',
                :mapLayersConfigs='camadasMapa',
                :mapConfig='configuracoesMapa',
                :camadaCentralizadaNome='camadaCentralizadaNome'
            )
</template>

<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet.vue';
import TabelaMonitoramentoAgricolaParaguai from '@/components/monitoramento/TabelaMonitoramentoAgricolaParaguai';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import FileGenerationUtils from '@/utils/FileGenerationUtils';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import TerritorioService from '@/services/TerritorioService';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import constantes from '@/utils/constantes';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapActions, mapState } from 'vuex';

const ICONE_PONTO_MAPA = L.icon({
    iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
    iconSize: [18, 26]
});

export default {
    name: 'ListaMonitoramentoAgricolaParaguai',

    components: {
        Mapa,
        TabelaMonitoramentoAgricolaParaguai,
        BaseButton
    },

    props: {
        filtros: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: false,
                    buscarCarControl: true
                },
                inspecionar: true,
                diagnostico: true
            },
            territorios: [],
            territoriosBuffer: [],
            larguraTotal: false,
            keyMapa: 1,
            keyLista: 10,
            paginaAreasMonitoradas: {
                itens: []
            },
            paginacao: {
                tamanho: constantes.TAMANHO_PAGINA,
                pagina: 0,
                ordenacao: 'territorio'
            },
            camadaCentralizadaNome: null,
            carregando: true
        };
    },

    watch: {
        filtros() {
            this.paginacao.pagina = 0;
            this.filtrarAreasMonitoradas();
        }
    },

    async created() {
        await this.filtrarAreasMonitoradas();
    },

    async mounted() {
        this.conectarWebsocket();

        this.idMunicipio = this.$route.params.idMunicipio;
        if (this.idMunicipio) {
            await this.mostrarMunicipio(this.idMunicipio);
        } else {
            await setTimeout(() => {
               this.buscarTerritorios();
            }, 1000);
        }
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        ...mapActions(['setfiltroMonitoramento']),
        ocultarBotaoGrupoOlfar() {
            return this.usuarioLogado?.idGrupo !== '59d650ab-0b3a-4d17-b656-8f44bec277dc';
        },
        organizarLayout: function () {
            this.keyMapa++;
            this.larguraTotal = !this.larguraTotal;
        },

        async buscarTerritorios() {
            try {
                this.loadingVisivel = true;
                await TerritorioService.findByMapaAgricola(this.filtros);
            } catch (error) {
                this.loadingVisivel = false;
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os territórios.'
                });
            }
        },

        mostrarTerritorios() {
            this.camadasMapa = [];

            this.territorios.forEach(({ id, centroide, ...informacoes }) => {
                let geoJson = centroide;
                if (typeof centroide === 'string') {
                    geoJson = JSON.parse(geoJson);
                }

                this.camadasMapa.push({
                    name: 'centroid' + id,
                    geoJson,
                    icon: ICONE_PONTO_MAPA,
                    popup: this.criarPopup({id, ...informacoes}),
                        acaoClick: () =>
                            this.mostrarDetalhesTerritorio({id, geoJson})
                });
            });

            if (this.territorios.length === 1) {
                this.camadaCentralizadaNome = 'centroid' + this.territorios[0].id;
            } else {
                this.camadaCentralizadaNome = null;
            }
        },

        async filtrarAreasMonitoradas() {
            try {
                this.carregando = true;
                const { data } =
                await MonitoramentoAgricolaService.buscarAreasMonitoradas(
                    this.filtros,
                    this.paginacao
                    );
                this.paginaAreasMonitoradas = data;
                this.buscarTerritorios();
                this.carregando = false;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.filtrarAreasMonitoradas')
                });
            }
        },

        salvarFiltroMonitoramento() {
            this.setfiltroMonitoramento(this.filtros);
        },

        ordenar(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.filtrarAreasMonitoradas();
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.filtrarAreasMonitoradas();
            this.$emit('buscarTotalizadores');
        },

        mostrarDetalhesTerritorio({id, geometria}) {
            const exibindoTerritorio = !!this.camadasMapa.find(
                ({ name }) => name === 'territorioExibido' + id
            );
            if (!exibindoTerritorio) {
                this.camadasMapa.push({
                    name: 'territorioExibido' + id,
                    geoJson: geometria,
                    style: getEstiloGeometria('area')
                });
            }

            this.camadaCentralizadaNome = 'territorioExibido' + id;
        },

        criarPopup({id, nome, nivel2Nome, nivel1Sigla }) {
            const button = document.createElement('button');
            button.classList.add('btn-realizar-diagnostico');
            button.innerText = this.$t('mensagens.monitoramentoAgricola.visualizarMonitoramento');
            button.addEventListener('click', () => {
                this.visualizarAreaMonitorada(id);
            });

            const div = document.createElement('div');
            div.innerHTML = `
                <h3>${this.$t('mensagens.territorio.titulo')}:</h3>
                <h4>${nome}</h4>
                <br>
                <h3>${this.$t('mensagens.comuns.monitoramento.localidade')}:</h3>
                <h4>${nivel2Nome} - ${nivel1Sigla}</h4>
                <br>
                <br>
            `;

            div.appendChild(button);

            return div;
        },

        visualizarAreaMonitorada(id) {
            this.$router.push({
                name: 'MonitoramentoAgricolaImovel',
                params: { id: id }
            });
        },

        async conectarWebsocket() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: 'Não foi possível conectar no serviço!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/area-monitoramento-agricola/territorios`,
                    response => {
                        if (response) {
                            const data = JSON.parse(response);
                            this.territorios = data;
                            this.territoriosBuffer = data;
                            this.mostrarTerritorios();
                        } else {
                            this.$notify.error({
                                message: 'Não foi possível buscar os territórios!'
                            });
                        }
                        this.loadingVisivel = false;
                    }
                );
            } catch (error) {
                this.loadingVisivel = false;
                this.$notify.error({
                    message: 'Não foi possível buscar os territórios!'
                });
            }
        },

        buscarPlanilhaMonitoramento() {
            FileGenerationUtils.cadastrarArquivoFilaProcessamento(this, 'PLANILHA_MONITORAMENTO_AGRICOLA');
        }
    }
};
</script>

<style lang="scss" scoped>
#lista-monitoramento-agricola {
    .reorganizarMapaTabela {
        font-size: 16px;
        margin-bottom: 16px;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .reorganizarMapaTabela--reorganizar-icon {
            padding: 10px;
            padding-bottom: 3px;
            background: var(--white);
            box-shadow: 0px 1px 7px 0px var(--block-shadow);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            cursor: pointer;

            i::before {
                width: 7px !important;
                height: 23px !important;
                background: #3b3b3b;
            }
            &.rotate {
                i::before {
                    transform: rotate(90deg);
                }
            }
        }
    }
    .lista-monitoramento-agricola__container {
        display: flex;
        flex-wrap: wrap;
        height: calc(100vh - 241px);
        .territorio-monitoramento-tabela {
            width: 59%;

            .tabela {
                padding-top: 0px;
                padding-bottom: 10px;
                margin-right: 10px;
                width: calc(100% - 10px);
            }
        }
        .territorio-monitoramento-mapa {
            width: 41%;
            height: 633px;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 1px 5px 0px var(--block-shadow);
            margin-bottom: 14px;
            #mapa-listagem-territorio {
                border-radius: 6px;
            }
        }

        &.isOrganizarWidth {
            .territorio-monitoramento-tabela,
            .territorio-monitoramento-mapa {
                width: 100% !important;
            }
            .territorio-monitoramento-mapa {
                order: 1;
            }
            .territorio-monitoramento-tabela {
                order: 2;
                h3 {
                    margin-top: 12px !important;
                }
                .tabela {
                    margin-right: 0px !important;
                }
            }
        }
    }
    h3 {
        margin-top: -40px;
        color: var(--var(--black));
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }
    .dimensao-mapa {
        height: 100% !important;
    }
}
</style>
